/* =====================================================================
   STARTUS CLOUD — editorial runtime (sc-article.js)
   Paired with sections/sc-article.liquid and sections/sc-blog-list.liquid.

   Everything here is progressive enhancement over server-rendered markup:
   the article reads perfectly with JavaScript off. This adds the contents
   rail, scroll spy, reading progress, share and the blog tag filter.
   ===================================================================== */
(function () {
  'use strict';

  var SC = (window.SC = window.SC || {});
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function slugify(s) {
    return String(s).toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  /* ───────────────────────────────────────────────────── article ── */

  function initArticle(root) {
    var body = $('[data-art-body]', root);
    if (!body) return;

    /* Wide tables must scroll inside their own box rather than pushing the
       whole article sideways on a phone. */
    $$('table', body).forEach(function (t) {
      if (t.parentNode && t.parentNode.classList.contains('art-table-wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'art-table-wrap';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });

    /* Contents, built from the H2s the author actually wrote. Anchors are
       added here rather than asked of the author, so pasted HTML just works. */
    var toc = $('[data-art-toc]', root);
    var list = toc ? $('ol', toc) : null;
    var heads = $$('h2', body);
    if (list && heads.length >= 3) {
      var used = {};
      heads.forEach(function (h) {
        var id = h.id;
        if (!id) {
          id = slugify(h.textContent);
          if (used[id]) { used[id]++; id = id + '-' + used[id]; } else { used[id] = 1; }
          h.id = id;
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;

      // Scroll spy — highlight the section the reader is actually in.
      var links = $$('a', list);
      if ('IntersectionObserver' in window) {
        var seen = {};
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { seen[e.target.id] = e.isIntersecting ? e.intersectionRatio : 0; });
          var best = null, bestRatio = 0;
          heads.forEach(function (h) {
            var r = seen[h.id] || 0;
            if (r > bestRatio) { bestRatio = r; best = h.id; }
          });
          if (!best) return;
          links.forEach(function (a) {
            a.classList.toggle('is-current', a.getAttribute('href') === '#' + best);
          });
        }, { rootMargin: '-15% 0px -70% 0px', threshold: [0, 0.25, 0.5, 1] });
        heads.forEach(function (h) { spy.observe(h); });
      }
    } else if (toc) {
      toc.hidden = true;
    }

    /* Reading progress across the body only, not the whole document —
       the footer and related posts should not count as "read". */
    var bar = $('[data-art-progress]', root);
    if (bar) {
      var tick = function () {
        var r = body.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var done = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : (r.top < 0 ? 1 : 0);
        bar.style.width = (done * 100).toFixed(2) + '%';
      };
      tick();
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick);
    }

    /* Share */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-art-share]');
      if (!btn) return;
      var kind = btn.getAttribute('data-art-share');
      var url = window.location.href;
      var title = (root.getAttribute('data-art-title') || document.title);
      if (kind === 'copy') {
        e.preventDefault();
        var done = function (msg) {
          var live = $('[data-art-share-status]', root);
          if (live) { live.textContent = msg; setTimeout(function () { live.textContent = ''; }, 3000); }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(
            function () { done('Link copied.'); },
            function () { done('Copy this page’s address to share it.'); });
        } else { done('Copy this page’s address to share it.'); }
        return;
      }
      if (kind === 'native') {
        if (navigator.share) { e.preventDefault(); navigator.share({ title: title, url: url }); }
      }
    });
  }

  /* ──────────────────────────────────────────────────── blog list ── */

  function initBlogList(root) {
    var chips = $$('[data-bl-tag]', root);
    if (!chips.length) return;
    var cards = $$('[data-bl-card]', root);
    var empty = $('[data-bl-empty]', root);

    function apply(tag) {
      var shown = 0;
      cards.forEach(function (c) {
        var tags = (c.getAttribute('data-tags') || '').split('|').filter(Boolean);
        var on = !tag || tags.indexOf(tag) > -1;
        c.hidden = !on;
        if (on) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      chips.forEach(function (b) {
        var on = b.getAttribute('data-bl-tag') === tag;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // Shareable, and survives a refresh.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (tag) url.searchParams.set('tag', tag); else url.searchParams.delete('tag');
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-bl-tag]');
      if (!chip) return;
      var tag = chip.getAttribute('data-bl-tag');
      apply(chip.classList.contains('is-on') ? '' : tag);
    });

    var initial = new URL(window.location.href).searchParams.get('tag');
    if (initial) apply(initial);
  }

  /* ───────────────────────────────────────────────────────── boot ── */

  function boot(scope) {
    $$('[data-sc-article]', scope || document).forEach(function (el) {
      if (el.__scArticle) return;
      el.__scArticle = true;
      initArticle(el);
    });
    $$('[data-sc-bloglist]', scope || document).forEach(function (el) {
      if (el.__scBlogList) return;
      el.__scBlogList = true;
      initBlogList(el);
    });
  }

  SC.initArticle = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }

  document.addEventListener('shopify:section:load', function (e) {
    var a = e.target && e.target.querySelector('[data-sc-article],[data-sc-bloglist]');
    if (a) { a.__scArticle = null; a.__scBlogList = null; boot(e.target); }
  });
})();
